import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.access-bg {
  background: linear-gradient(135deg, #1c1917 0%, #292524 40%, #44403c 100%);
}

.access-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
}

.floating-shape {
  border-radius: 50%;
  opacity: 0.1;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-20px) rotate(5deg);
  }
  66% {
    transform: translateY(10px) rotate(-3deg);
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = this.roleHome(this.service.auth.session?.role);
    }

    public roleHome(role: string = 'researcher') {
        const normalized = this.normalizedRole(role);
        if (normalized === 'admin') return '/collections';
        if (normalized === 'reviewer') return '/review';
        return '/chat';
    }

    public normalizedRole(role: string = 'researcher') {
        const value = String(role || 'researcher').toLowerCase();
        if (['admin', 'administrator', 'superadmin', 'editor', 'manager', 'owner', '관리자'].includes(value)) return 'admin';
        if (['reviewer', '검수자'].includes(value)) return 'reviewer';
        return 'researcher';
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async switchView(v: string) {
        this.view = v;
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.loginData));
        if (!user.email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = this.roleHome(data.role);
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.signupData));
        if (!user.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (user.password.length < 8) {
            await this.alert("비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        let { code, data } = await wiz.call("signup", {
            name: user.name,
            email: user.email,
            password: user.password
        });

        if (code == 200) {
            await this.alert("회원가입이 완료되었습니다. 로그인해주세요.", 'success');
            this.view = 'login';
            this.loginData.email = user.email;
            this.loginData.password = '';
            await this.service.render();
        } else {
            await this.alert(data.message || "회원가입에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;